import React from "react";
import "../../../../CompletedAssessment/Invite-Respondants-Modal/invite-respondants-modal.css";

const Renderconfirmmessagemodal = (props) => {
  return (
    <div className="message-wrapper">
      {props.invitationsSuccessMessage.map((showMessages, index) => {
        return showMessages.map((getMessage) => {
          const keyName = Object.keys(getMessage)[0];
          const message = Object.values(getMessage)[0];

          if (typeof message === "object" && Array.isArray(message.__all__)) {

            const formattedMessage = `${keyName}:${message.__all__[0]}`;
            return (
              <p key={index} style={{ color: "#000" }}>
                <span>{formattedMessage}</span>
              </p>
            );
          } else {
            return (
              <p key={index} style={{ color: "#000" }}>
                {keyName === "success" ? (
                  <span>{message}</span>
                ) : (
                  <span>
                    {keyName}: {message}
                  </span>
                )}
              </p>
            );
          }
        });
      })}
    </div>
  );
};

export default Renderconfirmmessagemodal;


// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Sent/Invitation-Modal/confirm-modal/index.jsx